import { StrategyId } from './search-strategy.model';

export interface SearchEngineConfig {
  minQueryLength: number;
  maxResults: number;
  fuzzyThreshold: number;
  includeRelated: boolean;
  enabledStrategies: ReadonlyArray<StrategyId>;
  weightOverrides?: Partial<Record<StrategyId, number>>;
  /** When true, surfaces ScoredMatch[] details in UI for debugging */
  debug?: boolean;
}

export const DEFAULT_SEARCH_CONFIG: SearchEngineConfig = {
  minQueryLength: 2,
  maxResults: 20,
  fuzzyThreshold: 0.7,
  includeRelated: true,
  enabledStrategies: [
    'exact',
    'fuzzy',
    'ngram',
    'keyword',
    'semantic',
    'intent',
    'token',
    'compound-split',
  ],
  debug: false,
};
